<template>
  <v-row v-if="task != null">
    <v-col cols="12" md="3">
      <div class="text-caption text-medium-emphasis">Tipo</div>
      <div>{{ task.task_type ? task.task_type.name : "-" }}</div>
    </v-col>
    <v-col cols="12" md="3">
      <div class="text-caption text-medium-emphasis">Estado</div>
      <v-chip size="small" :color="taskService.getStateColor(task.state ? task.state.id : null)">
        {{ task.state ? task.state.name : "-" }}
      </v-chip>
    </v-col>
    <v-col cols="12" md="3">
      <div class="text-caption text-medium-emphasis">Prioridad</div>
      <v-chip v-if="task.prioridad" size="small" :color="taskService.getPrioridadColor(task.prioridad)">
        {{ task.prioridad }}
      </v-chip>
      <span v-else>-</span>
    </v-col>
    <v-col cols="12" md="3">
      <div class="text-caption text-medium-emphasis">Almacén</div>
      <div>{{ task.almacen ? task.almacen.name : "-" }}</div>
    </v-col>

    <v-col cols="12" md="3">
      <div class="text-caption text-medium-emphasis">Creación</div>
      <div>
        {{ task.creation_date ? task.creation_date.split(" ")[0] : "-" }}<br />
        <span class="text-caption text-grey-600">{{ task.creation_date ? task.creation_date.split(" ")[1] : "" }}</span>
        <span class="text-caption text-grey-600">{{ task.user_create ? " - " + task.user_create.name : "" }}</span>
      </div>
    </v-col>
    <v-col cols="12" md="3">
      <div class="text-caption text-medium-emphasis">Planificada</div>
      <div>{{ task.scheduled_date || "-" }}</div>
    </v-col>
    <v-col cols="12" md="3">
      <div class="text-caption text-medium-emphasis">Asignada</div>
      <div v-if="task.assigned_date">
        {{ task.assigned_date.split(" ")[0] }}<br />
        <span class="text-caption text-grey-600">{{ task.assigned_date.split(" ")[1] }}</span>
        <span class="text-caption text-grey-600">{{ task.assigned_user ? " - " + task.assigned_user.name : "" }}</span>
      </div>
      <span v-else>-</span>
    </v-col>
    <v-col cols="12" md="3">
      <div class="text-caption text-medium-emphasis">Inicio / Fin</div>
      <div>{{ task.start_date || "-" }}</div>
      <div>{{ task.end_date || "-" }}</div>
    </v-col>

    <v-col cols="12" v-if="task.observations">
      <div class="text-caption text-medium-emphasis">Observaciones</div>
      <div>{{ task.observations }}</div>
    </v-col>
  </v-row>
</template>

<script>
import { taskService } from "@/libs/ws/taskService";

export default {
  name: "TaskViewHeader",
  props: {
    task: Object,
  },
  data() {
    return {
      taskService: taskService,
    };
  },
};
</script>
